module.exports = __webpack_public_path__ + "static/media/050.ffb581e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/050.jpg
// module id = 345
// module chunks = 0